import React from 'react'
import Aux from '../../hoc/Auxiliary'
import Header from '../../components/Header'
import MainNav from '../../components/MainNav'
import { NavLink } from 'react-router-dom'
import {Breadcrumbs} from 'react-breadcrumbs-dynamic'
import Footer from '../../components/Footer'

class PageLayout extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            openNav: false,
            isScrolled: false,
            isMobile: window.innerWidth <= 740
        }
    }
    onSideMenuOpen = () => {
        this.setState({
            openNav: true
        })
    }

    onSideMenuClose = () => {
        this.setState({
            openNav: false
        })
    }

	componentDidMount = () => {
		window.addEventListener('scroll', this.handleScroll);
		window.addEventListener('resize', this.handleResize);
	}

	componentWillUnmount = () => {
		window.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('resize', this.handleResize);
	}

	handleScroll = event => {
		this.setState({
		  isScrolled: window.pageYOffset > 0
		})
	}

	handleResize = event => {
		this.setState({
			isMobile: window.innerWidth <= 740
		})
	}

    render () {
        const { openNav, isScrolled, isMobile } = this.state
        const { children, isHome, showBreadcrumbs } = this.props
        return <Aux>
            <div className={`c-sidenav ${this.state.openNav ? 'openNav' : ''}`}>
                <button className='c-sidenav__close-btn c-btn--transparent' onClick={this.onSideMenuClose}>
					<img src='/img/close.svg' alt='close menu icon' />
				</button>
                <MainNav isSideNav/>
            </div>
            <div className={`c-main${ !isHome ? ' c-main--inner' : '' }${ openNav ? ' openNav' : ''}${ isScrolled ? ' scrolled' : ''}`}>
		        <Header isHome={isHome} isScrolled={isScrolled} isMobile={isMobile} onSideMenuOpen={this.onSideMenuOpen}/>
                    { showBreadcrumbs &&
                        <div className='u-margin-vertical u-padding-horizontal c-breadcrumbs'>
                            <Breadcrumbs
                                className='u-margin-vertical'
                                container={'div'}
                                separator={<b> / </b>}
                                item={NavLink}
                                finalItem={'b'}
                                finalProps={{
                                    style: {margin: '24px 0'}
                                }}
                            />
                        </div>
                    }
                    { children }
		        <Footer />
            </div>
        </Aux>
    }
}

export default PageLayout



// WEBPACK FOOTER //
// ./src/components/layouts/PageLayout.js